import { FsStage } from "db/model/tour/FsStage";
import { Stage } from "model/Tour/Stage";
import { nonEmptyStrings, nonUndefined } from "Utility";

export const mapStages = (fsModels: FsStage[]) => {
  return nonUndefined(fsModels.map(mapStage));
};

const mapStage = (fsModel: FsStage): Stage | undefined => {
  if (!fsModel.stageId) {
    return undefined;
  }

  return {
    id: fsModel.stageId,
    name: fsModel.name,
    shortName: fsModel.shortName ?? fsModel.name,
    tournamentIds: nonEmptyStrings(fsModel.tournamentIds ?? []),
    trackIds: nonEmptyStrings(fsModel.trackIds ?? []),
  };
};
